
import { ResellerOrder } from "@/types/resellerOrder";
import { resellerOrders } from "./types";

/**
 * Get all reseller orders
 */
export const getResellerOrders = async (): Promise<ResellerOrder[]> => {
  // Simulate API request delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  return [...resellerOrders];
};

/**
 * Get pending reseller orders
 */
export const getPendingResellerOrders = async (): Promise<ResellerOrder[]> => {
  // Simulate API request delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  return resellerOrders.filter(order => order.status === 'pending');
};

/**
 * Get an order by ID
 */
export const getResellerOrderById = async (orderId: string): Promise<ResellerOrder | null> => {
  // Simulate API request delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const order = resellerOrders.find(order => order.id === orderId);
  return order || null;
};

/**
 * Get orders that are ready for activation (past the waiting period)
 */
export const getOrdersReadyForActivation = async (): Promise<ResellerOrder[]> => {
  // Simulate API request delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const now = new Date();
  
  return resellerOrders.filter(order => 
    order.status === 'approved' && 
    order.waitingPeriod === 'active' &&
    order.scheduledActivationTime && 
    order.scheduledActivationTime <= now &&
    order.paymentVerified
  );
};
